import type { StoreActionApi } from 'react-sweet-state';

import type { FieldId, FieldInternalValue, FieldType } from '../../../../common/types/field';
import type { IssueAdjustmentsState, StoreContainerProps } from '../../types';
import { calculateNextFormValue } from '../../utils/calculate-next-form-value';

type SetFieldValuePayload = {
	fieldId: FieldId;
	fieldType: FieldType;
	fieldValue: FieldInternalValue;
};

/**
 * Sets new field value after intialization. Used for handling e.g. real-time refresh in the Issue View.
 *
 * Warning:
 * - If you want to handle the UI modification onChange, use `processChange` action instead.
 * - If you want to initialize the field, use `initializeField` action instead.
 */
export const setFieldValue =
	({ fieldId, fieldType, fieldValue }: SetFieldValuePayload) =>
	(
		{ getState, setState }: StoreActionApi<IssueAdjustmentsState>,
		{ viewType }: StoreContainerProps,
	): void => {
		const { internalFormMetadata, formData } = getState();

		/**
		 * We can set new field value only if the field was initialized.
		 * This checks the field metedata that indicates the successfull initialization.
		 */
		if (!internalFormMetadata[fieldId]) {
			return;
		}

		const nextFormData = calculateNextFormValue({
			internalFormMetadata,
			formData,
			fieldType,
			fieldId,
			fieldValue,
			viewType,
		});

		if (nextFormData === null) {
			return;
		}

		setState({ formData: nextFormData });
	};
